export const DOWNLOAD_RESULT_PDF_FILE_FAILURE = 'DOWNLOAD_RESULT_PDF_FILE_FAILURE';

export const downloadResultPdfFileFailure = error => ({
    type: DOWNLOAD_RESULT_PDF_FILE_FAILURE,
    payload: error,
    error: true,
});
